export const address = {
  addressForm: {
    title: 'Title',
    titleOptional: 'Title (optional)',
    defaultTitle: 'Title',
    company: {
      label: 'Company',
      placeholder: 'Company',
    },
    complement: {
      label: 'Complement',
      placeholder: 'Complement',
    },
    firstName: {
      label: 'First Name',
      placeholder: 'First Name',
    },
    lastName: {
      label: 'Last Name',
      placeholder: 'Last Name',
    },
    address1: 'Address',
    address2: 'Street Number (optional)',
    country: 'Country/Region',
    city: {
      label: 'City',
      placeholder: 'City',
    },
    state: 'State/Region',
    zipCode: {
      label: 'Postal Code',
      placeholder: 'Postal Code/ZIP',
    },
    phoneNumber: {
      label: 'Phone Number (optional)',
      placeholder: '...',
    },
    cellphone: {
      label: 'Cell Phone Number (optional)',
      placeholder: '...',
    },
    saveAsDefault: 'Save as default',
    chooseAddress: 'Choose Address',
    streetAddress: 'Street Address',
    aptSuite: 'Apt/Suite Number',
    selectOne: 'Select One...',
    setAsDefault: 'Set as default delivery address',
    titleRequired: 'Title is required.',
    userAddressAddSuccess: 'New address added successfully!',
    userAddressUpdateSuccess: 'Address updated successfully!',
    userAddressDeleteSuccess: 'Address deleted successfully!',
    invalidAddress: 'Invalid Address',
  },
  addressBook: {
    addNewDeliveryAddress: 'Request new shipaddress',
    editDeliveryAddress: 'Edit address',
    areYouSureToDeleteAddress: 'Are you sure you want to delete this address? This action cannot be undone.',
    addNewAddress: 'Add New Address',
    requestAddNewAddress: 'Request New Address',
    addAddress: 'Request registration',
    updateAddress: 'Update address',
    backToAddressList: 'Back to address list',
    defaultDeliveryAddress: 'Default Delivery Address',
    additionalDeliveryAddress: 'Additional Delivery Address {{number}}',
    noContent: 'No address available.',
    shipAddress: {
      title: 'Ship to Address',
      titleForm: 'Request a New Ship-to Address',
      table: {
        header: {
          address: 'Address',
          defaultWarehouseCode: 'Default Warehouse',
          phone: 'Phone',
          actions: 'Default',
        },
      },
      actions: {
        makeDefault: 'Make Default',
      },
      successRequest: 'Request to add address successfully completed, the address will be analyzed by our employees.',
    },
    dropShip: {
      title: 'Drop Ship Address',
      titleForm: 'New Drop Ship Address',
      table: {
        header: {
          address: 'Address',
          phone: 'Phone',
        },
      },
      actions: {
        edit: 'Edit',
        delete: 'Delete',
      },
    },
    cancel: 'Cancel',
    delete: 'Delete',
  },
  addressCard: {
    default: 'DEFAULT',
    selected: 'Selected',
    setAsDefault: 'Set as default',
    shipTo: 'Ship To',
    billTo: 'Bill To',
    phoneNumber: 'P',
    mobileNumber: 'C',
  },
  addressSuggestion: {
    verifyYourAddress: 'Verify Your Address',
    ensureAccuracySuggestChange: 'To ensure delivery accuracy, we suggest the selected change below.',
    chooseAddressToUse: 'Please choose which address you would like to use:',
    suggestedAddress: 'Suggested Address',
    enteredAddress: 'Entered Address',
    editAddress: 'Edit Address',
    saveAddress: 'Save Address',
  },
  addressMessages: {
    setAsDefaultSuccessfully: 'The address {{ streetAddress }} has been successfully set as default',
  },
};